module.exports = __webpack_public_path__ + "static/media/bdm.cfdb9344.jpg";